<template>
    <window-portal :open="dataProps.show" @close="() => {
        dataProps.show = false
        if (dataProps?.closeCallback) {
            dataProps?.closeCallback()
        };
    }">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center>
                <div>
                    <p style="font-size: 30px;">Vista Previa de Impresión de Libro Diario Mayor {{ dataProps.data.bookType == 'consolidated' ? 'Consolidado' : 'Detallado' }}</p>
                </div>
            </center>
            <br />
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="Print">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download">
                    Descargar
                </button>
            </center>
            <center>
                <div v-if="loading">
                    <p>Cargando...</p>
                </div>
            </center>
        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>
        <div class="book" style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
            <div style="margin: 0 auto; width: 1000px;">
                <div ref="dataprint" style="margin: 0 !important; padding: 0 !important; line-height: normal;">
                    <div v-for="(page, indexPage) in pages" :key="indexPage" style="position: relative; width: 1000px; height: 1294px; box-sizing: border-box; overflow: hidden; background: white;">
                        <hr style="margin: 0; border: 0; border-top: 1px solid black;" />
                        <div class="subpage" style="height: 1293px; padding-top: 20px; box-sizing: border-box; overflow: hidden;">
                            <div style="margin-left: 20px; margin-right: 20px;">
                                <div style="text-align: center; font-size: 14px; text-transform: uppercase;">
                                    "{{ dataProps.data.business.BusinessBillingName }}"
                                </div>
                                <div style="text-align: center; font-size: 14px; text-transform: uppercase;">
                                    Libro Diario Mayor {{ dataProps.data.bookType == 'consolidated' ? 'Consolidado' : 'Detallado' }} al {{ getLastDayOfMonthText }}
                                </div>
                                <div v-if="dataProps.data.business.Currency == '$'" style="text-align: center; font-size: 10px; margin-top: 15px;">
                                    <!-- US DOLAR -->
                                    VALORES EXPRESADOS EN DOLARES DE LOS ESTADOS UNIDOS DE AMERICA
                                </div>
                                <div style="text-align: right; font-size: 12px;">
                                    Pág. {{ indexPage + 1 }}/{{ numPages }}
                                </div>
                                <table style="width: 100%; margin-top: 15px; border-collapse: collapse;">
                                    <thead>
                                        <tr style="font-size: 12px; text-align: left;">
                                            <td style="border-top: 1px solid black; border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px;">CUENTA</td>
                                            <td style="border-top: 1px solid black; border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px;"></td>
                                            <td style="border-top: 1px solid black; border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px;">NOMBRE</td>
                                            <td style="border-top: 1px solid black; border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px;"></td>
                                            <td style="border-top: 1px solid black; border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px;width: 3cm;">SALDO ANT.</td>
                                            <td style="border-top: 1px solid black; border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px;width: 3cm;">DEBE</td>
                                            <td style="border-top: 1px solid black; border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px;width: 3cm;">HABER</td>
                                            <td style="border-top: 1px solid black; border-bottom: 1px solid black; padding-top: 5px; padding-bottom: 5px;width: 3cm;">SALDO ACT.</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="height: 7px;"></tr>
                                        <tr v-for="(transaccion, index) in valuesRows[indexPage]" :key="index" style="font-size: 12px;">
                                            <td style="padding-top: 0px;">{{ valuesRows[indexPage]?.[index].first ? transaccion.account_code : '' }}</td>
                                            <td></td>
                                            <td style="padding-top: 0px;">{{ valuesRows[indexPage]?.[index].last ? '' : valuesRows[indexPage]?.[index].first ? `${transaccion.concept}` : `${transaccion.main_column} MOVIMIENTO DEL
                                                DIA` }}</td>
                                            <td></td>
                                            <td style="padding-top: 0px;">{{ valuesRows[indexPage]?.[index].first ? transaccion.initial_balance : '' }}</td>
                                            <td :style="`padding-top: 0px; ${valuesRows[indexPage]?.[index].last ? 'border-top: 1px solid black;' : ''}`">{{ valuesRows[indexPage]?.[index].first ? '' : transaccion.charges }}</td>
                                            <td :style="`padding-top: 0px; ${valuesRows[indexPage]?.[index].last ? 'border-top: 1px solid black;' : ''}`">{{ valuesRows[indexPage]?.[index].first ? '' : transaccion.payments }}</td>
                                            <td style="padding-top: 0px;">{{ `${valuesRows[indexPage]?.[index].last ? valuesRows[indexPage]?.[index].current_balance : ''}` }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-if="indexPage + 1 === numPages">
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                                <div :style="style.signatures">
                                    <div :style="style.leftSignature">
                                        <div>__________________________________</div>
                                        <div>{{ AccountantName ?? 'Contador' }}</div>
                                        <div>{{ AccountantAdditional ?? '' }}</div>
                                        <div>{{ `${AccountantName ? 'Contador' : ''}` }}</div>
                                    </div>
                                    <div :style="style.rightSignature">
                                        <div>__________________________________</div>
                                        <div>{{ AuditorName ?? 'Auditor' }}</div>
                                        <div>{{ AuditorAdditional ?? '' }}</div>
                                        <div>{{ `${AuditorName ? 'Auditor' : ''}` }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"

export default {
    name: "PrintMayorDailyBookNew",
    props: {
        dataProps: {
            type: Object,
            default: () => ({})
        },
    },
    components: { WindowPortal },
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            numPages: 0,
            mailLabel: null,
            valuesRows: [],
            urlQr: null,
            specialinvoicescolor: JSON.parse(localStorage.getItem("user")).specialinvoicescolor,
            specialInvoicesTitleColor: JSON.parse(localStorage.getItem('user')).specialInvoicesTitleColor,
            kitcoalternativeposclientdata: JSON.parse(localStorage.getItem("user")).kitcoalternativeposclientdata,
            lexlitislatamclientdata: JSON.parse(localStorage.getItem("user")).lexlitislatamclientdata,
            AccountantName: JSON.parse(localStorage.getItem("user")).AccountantName,
            AccountantAdditional: JSON.parse(localStorage.getItem("user")).AccountantAdditional,
            AuditorName: JSON.parse(localStorage.getItem("user")).AuditorName,
            AuditorAdditional: JSON.parse(localStorage.getItem("user")).AuditorAdditional,
            style: {
                signatures: {
                    display: 'flex',
                },
                leftSignature: {
                    width: '50%',
                    display: 'flex',
                    'flex-direction': 'column',
                    'justify-content': 'center',
                    'align-items': 'center',
                },
                rightSignature: {
                    width: '50%',
                    display: 'flex',
                    'flex-direction': 'column',
                    'justify-content': 'center',
                    'align-items': 'center',
                },
            },
        }
    },
    mounted() {
    },
    computed: {
        pages() {
            // Generar un arreglo con `numPages` elementos
            return Array.from({ length: this.numPages });
        },
        getLastDayOfMonthText() {
            const lastDay = new Date(this.dataProps.data.date.year, this.dataProps.data.date.month, 0);

            const months = [
                'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
            ];

            const day = lastDay.getDate();
            const monthName = months[lastDay.getMonth()]; 
            const yearText = lastDay.getFullYear();

            return `${day} de ${monthName} de ${yearText}`;
        }
    },
    watch: {
        'dataProps.show'() {
            if (this.dataProps.show) {
                setTimeout(async () => {
                    await this.calculatePagesOfDoc()
                }, 0);
            }
        }
    },
    methods: {
        calculatePagesOfDoc() {
            let pages = 0;
            let rows = 0;
            const maxRowsPerPage = 72;

            this.valuesRows = [];
            this.valuesRows[pages] = [];

            try {
                const body = this.dataProps.data.body;

                for (let index = 0; index < body.length; index++) {
                    let current = body[index];
                    if (rows >= maxRowsPerPage) {
                        pages++
                        this.valuesRows[pages] = []
                        rows = 0
                    }
                    this.valuesRows[pages].push(current)
                    rows++;
                }
                rows = rows + 14;
                if (rows >= maxRowsPerPage) {
                    pages++
                    this.valuesRows[pages] = []
                    rows = 0
                }
            } catch (err) {
                alert(err);
            }

            this.numPages = this.valuesRows.length
        },
        async Print() {
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function (doc) {
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            })
            this.removeTrailingBlankPages(doc)

            doc.autoPrint({ variant: 'non-conform' });
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },

        async Download() {
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')
            await doc.html(this.$refs.dataprint, {
                callback: function (doc) {
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 0.612,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });
            
            this.removeTrailingBlankPages(doc)
            doc.save("LibroDiarioMayor" + this.dataProps.data.bookType + ".pdf");

            this.loading = false
        },
        removeTrailingBlankPages(doc) {
            const expectedPages = Math.max(this.numPages, 1);
            const getPageCount = () => (
                typeof doc.getNumberOfPages === 'function'
                    ? doc.getNumberOfPages()
                    : doc.internal.getNumberOfPages()
            );

            while (getPageCount() > expectedPages) {
                doc.deletePage(getPageCount());
            }
        },
    }
}
</script>

<style scoped>
    .u-row .u-col-100{
        width: 100% !important;
    }
    .btnclean{
        border-radius: 15px;
        border: 1px solid white;
        background-color: #F29D35 !important;
        color: white !important;
    }
    .btnclose{
        border-radius: 15px;
        border: 1px solid white;
        background-color: rgb(255, 38, 38) !important;
        color: white !important;
       
    }

    * {
        font-family: Arial, Helvetica, sans-serif !important;
    }
</style>
